export default __webpack_public_path__ + "static/media/icon_awesome-code_bleu.4f0c6659.svg";